import ProfileUnauthPage from "./ProfileUnauthPage";

export default ProfileUnauthPage;

export * from "./ProfileUnauthPage";
